const youtubeLinks = document.querySelectorAll('.youtube a:not(.extern)');
[].forEach.call(youtubeLinks, (elem) => {
    elem.addEventListener('click', (event) => {
        event.preventDefault();
        const id = elem.dataset.id;
        const url = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=1';
        const width = elem.parentNode.offsetWidth;
        const height = width / 16 * 9;
        elem.parentNode.innerHTML = '<iframe width="' + width + '" height="' + height + '" src="' + url + '"></iframe>';
    });
});
